import PlansComparisonTable from './PlansComparisonTable';

export default PlansComparisonTable;
